module.exports = __webpack_public_path__ + "static/media/bu_pont_sans_tablier.01844a7e.jpg";